import SensorListPagingResultModelBase from '../_generated/modelBases/sensor-list-paging-result-model-base';

export default class SensorListPagingResultModel extends SensorListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
